

export function flattenAddress(address) {
  if (address === undefined)
    return "";
  return `${address.street_number} ${address.street}, ${address.postal_code} ${address.city}`;
}


export function mapUrl(destAddress, centerId, centers, srcAddress = null ) {
  if (srcAddress === null) {
    if(!centers){
      return '';
    }
    let center = centers.find(x => x.id === centerId);
    if(!center){
      return '';
    }
    srcAddress = center.address;
  }

  const src = flattenAddress(srcAddress).replace(/ /g, '+');
  const dst = flattenAddress(destAddress).replace(/ /g, '+');

  return `https://maps.google.com/?saddr=${src}&daddr=${dst}`;
}

export function mapUrlRound(addresses, centerId, centers, avoidHighways = false) {
  let addressesWithCenter = [];
  if(!centers){
    return '';
  }
  let center = centers.find(x => x.id === centerId);
  if(!center){
    return '';
  }
  addressesWithCenter.push(center.address);
  for (const ad of addresses) {
    addressesWithCenter.push(ad);
  }

  let flattenList = [];
  for (const ad of addressesWithCenter) {
    flattenList.push(flattenAddress(ad));
  }
  // Format « Maps URLs » officiel : accepte avoid=highways (périphérique et voies rapides évités —
  // les scooters ne peuvent pas les emprunter).
  const destination = flattenList[flattenList.length - 1];
  const waypoints = flattenList.slice(0, -1);
  return "https://www.google.com/maps/dir/?api=1"
    + (waypoints.length ? `&origin=${encodeURIComponent(waypoints[0])}` : "")
    + (waypoints.length > 1 ? `&waypoints=${encodeURIComponent(waypoints.slice(1).join("|"))}` : "")
    + `&destination=${encodeURIComponent(destination)}`
    + "&travelmode=driving"
    + (avoidHighways ? "&avoid=highways" : "");
}


export default { mapUrl, flattenAddress };
